// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { type ParseKeys, type Namespace, type TOptions } from 'i18next';
import type { ReactElement } from 'react';
import { Trans, useTranslation, type TransProps } from 'react-i18next';
import { type _DefaultNamespace } from 'react-i18next/TransWithoutContext';

export const Translation = <
  Key extends ParseKeys<Ns, TOpt, KPrefix>,
  Ns extends Namespace = _DefaultNamespace,
  KPrefix = undefined,
  TContext extends string | undefined = undefined,
  TOpt extends TOptions & { context?: TContext } = { context: TContext },
  E = React.HTMLProps<HTMLDivElement>,
>(
  props: TransProps<Key, Ns, KPrefix, TContext, TOpt, E>,
): ReactElement => {
  const { i18n } = useTranslation();

  return <Trans i18n={i18n} {...props} />;
};
